module.exports = __webpack_public_path__ + "img/background10.171cf5c1.jpg";